import styled from 'styled-components';
import Alert from '@mui/material/Alert';

const SAlert = styled(Alert)`
  & {
  }
`;

export default SAlert;
